import { useCallback, useContext, useEffect } from 'react';
import { Route, Redirect, HashRouter } from 'react-router-dom';
import { appPaths, getConfig } from './helpers';

import Dashboard from './pages/Dashboard';
import Builder from './pages/Builder';
import Welcome from './pages/Welcome';
import { AppContext } from './context/App';
import { StepsProvider } from './context/Steps';
import ErrorModal from './components/modals/ErrorModal';

function App() {
	const { errorMessage, dispatchConfig } = useContext(AppContext);

	const updateConfig = useCallback((payload: {}) => {
		dispatchConfig({ payload });
	}, [dispatchConfig]);

	useEffect(() => {
		getConfig().then((config) => {
			updateConfig({
				isWelcomeDone: config.isWelcomeDone,
				hasContributions: config.hasContributions,
				footerContribution: config.footerContribution,
				clientId: config.clientId
			});
		}).catch((error) => {
			updateConfig({ errorMessage: error.message });
		});
	}, [updateConfig]);

	return (
		<>
			{errorMessage && <ErrorModal message={errorMessage} />}

			<HashRouter>
				<Route exact path="/">
					<Redirect to={appPaths.dashboard} />
				</Route>
				<Route exact path={appPaths.dashboard}>
					<Dashboard />
				</Route>
				<Route path={`${appPaths.builder}/:id?`}>
					<StepsProvider>
						<Builder />
					</StepsProvider>
				</Route>
				<Route exact path={appPaths.welcome}>
					<Welcome />
				</Route>
			</HashRouter>
		</>
	);
}

export default App;
